import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import luckyGrid from '@/components/luckyGrid'
import luckyWheel from '@/components/luckyWheel'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'luckyGrid',
      component: luckyGrid
    },
    {
      path: '/luckyWheel',
      name: 'luckyWheel',
      component: luckyWheel
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js